// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.providers.appLoading.';

const APP_LOADING_DESCRIPTION = `${DOMAIN}description`,
  APP_LOADING_TITLE = `${DOMAIN}title`;

export { APP_LOADING_DESCRIPTION, APP_LOADING_TITLE };
